// window.otpLead = "https://otpauth.gbrapp.com/";
// window.otpLead = "https://registrystaging.gbrservice.com/"

// ABN BASE URLS

let ConsumerAdmin;
let AssetDeveloper;

// let newBaseUrlOEM;
// let newBaseUrl_oem;
// let proxyUrl;
// let gbrServiceUrl;
// let newBaseUrl;
// let baseUrl;
// let OpUserServiceUrl;
// let AgriBusinessRegistryServiceUrl;
// let ApplicationSpecificGwUrl ;
// let tradingServer;

if (process.env.REACT_APP_DEVELOPMENT_ENV === "production") {
  window.baseUrl = "https://registry.gbrservice.com/"; // eslint-disable-line no-unused-vars
  window.newBaseUrlOEM = "https://content.gbrservice.com/"; // eslint-disable-line no-unused-vars
  window.newBaseUrl_oem = "https://content.gbrservice.com/";
  window.proxyUrl = "https://content.gbrservice.com/";
  window.OpUserServiceUrl = "https://iam.gbrservice.com/";
  // newBaseUrl = 'https://iam.gbrservice.com/';
  ConsumerAdmin = process.env.REACT_APP_CONSUMER_ADMIN_PRODUCTION;
  AssetDeveloper = process.env.REACT_APP_ASSET_DEVELOPER_PRODUCTION;

  // WEBSITE PRODUCTION URLS
  window.newBaseUrlOEM = "https://content.gbrservice.com/";
  window.newBaseUrl_oem = "https://content.gbrservice.com/";
  window.proxyUrl = "https://content.gbrservice.com/";
  // window.gbrServiceUrl = "https://iam.gbrservice.com/";
  // window.newBaseUrl = "https://iam.gbrservice.com/";
  window.AgriBusinessRegistryServiceUrl = "http://15.206.178.137:8080/";
  window.otpLead = "https://registrygcp.gbrservice.com/"
  window.clientId = process.env.REACT_APP_CLIENT_ID_PRODUCTION;
  window.clientSecret = process.env.REACT_APP_CLIENT_SECRET_PRODUCTION;
  // WEBSITE PRODUCTION URL END
} else if (process.env.REACT_APP_DEVELOPMENT_ENV === "staging") {
  window.baseUrl = "https://registrystaging.gbrservice.com/";
  window.newBaseUrlOEM = "https://proxystaging.gbrservice.com/"; 
  window.newBaseUrl_oem = "https://proxystaging.gbrservice.com/"; 
  window.proxyUrl = "https://proxystaging.gbrservice.com/";
  // gbrServiceUrl = 'http://35.153.176.60:8080/';
  // newBaseUrl = 'http://35.153.176.60:8080/';
  // window.tradingServer = 'https://proxystaging.gbrservice.com';

  ConsumerAdmin = process.env.REACT_APP_CONSUMER_ADMIN_STAGING;
  AssetDeveloper = process.env.REACT_APP_ASSET_DEVELOPER_STAGING;
  window.OpUserServiceUrl = "https://iamstaging.gbrservice.com/";
  window.AgriBusinessRegistryServiceUrl =
    "https://registrystaging.gbrservice.com/";
  window.ApplicationSpecificGwUrl = "http://54.167.97.129:8080/"; 
  // WEBSITE STAGING BASE URL
  window.newBaseUrlOEM = "https://proxystaging.gbrservice.com/"; 
  window.newBaseUrl_oem = "https://proxystaging.gbrservice.com/"; 
  window.proxyUrl = "https://proxystaging.gbrservice.com/"; 
  window.otpLead = "https://registrystaging.gbrservice.com/";
  window.clientId = process.env.REACT_APP_CLIENT_ID_STAGING;
  window.clientSecret = process.env.REACT_APP_CLIENT_SECRET_STAGING;
  // window.newBaseUrl = 'http://35.153.176.60:8080/';
  // window.sendRequestUrl = 'http://18.205.21.225:8080/';
  // WEBSITE PRODUCTION END
}

window.appConfig = {
  /************************  Website URL's **************************************/
  productBasedonBrand:
    window.newBaseUrlOEM + "AgriProductProxy/getproducts/" + ConsumerAdmin,
  productList: window.newBaseUrlOEM + "AgriProductProxy/getproductlist/",
  getMobileNumber: window.OpUserServiceUrl + "OpUserService/consumerReqInfo/",
  weatherUpdate: window.proxyUrl + "EAP/getallsites/",
  // getOtp: window.otpLead + "otp/lead",
  // validateOtp: window.otpLead + "validateOtp",
  // resendOTP: window.otpLead + "resendOtp",

  // getOtp: window.otpLead + "OTPAuthenticationService/otp/lead",
  // validateOtp: window.otpLead + "OTPAuthenticationService/validateOtp",
  // resendOTP: window.otpLead + "OTPAuthenticationService/resendOtp/",

  clientId: window.clientId,
  clientSecret: window.clientSecret,

  getOtp: window.otpLead + "OTPAuthenticationService/",
  validateOtp: window.otpLead + "OTPAuthenticationService/validateOtp/",
  resendOTP: window.otpLead + "OTPAuthenticationService/resendOtp/",
  getsubCategoriesBasedonAdminandCategory:
    window.proxyUrl + "ContentGw/getAllContentSubCategories/",
  PublicAccessToken: window.OpUserServiceUrl + "AuthBackEndGw/token/",
  TokenRelam: ConsumerAdmin,
  Relam: ConsumerAdmin + "/",
  AssetDeveloperValue: AssetDeveloper,
  getProductsBasedonAdminUser:
    window.newBaseUrlOEM + "AgriProductProxy/allproducts/",
  getProducts: window.newBaseUrlOEM + "AgriProductProxy/product/",
  allConsumerUsreswithAssetType:
    window.OpUserServiceUrl + "OpUserService/getAllConsumerUsers/",
  allConsumerUsres:
    window.OpUserServiceUrl + "OpUserService/getAllConsumerUsers/",
  getAssetVerticals: window.newBaseUrlOEM + "EAP/getAssetVerticals/",
  getCategories: window.newBaseUrlOEM + "EAP/categoryType/",
  getAssetType: window.newBaseUrlOEM + "EAP/assetType/",
  getModel: window.newBaseUrlOEM + "EAP/models/",
  productLikeCount: window.newBaseUrlOEM + "AgriProductProxy/updateLikeCount/",
  getContentCategories: window.proxyUrl + "ContentGw/getCategories/",
  getContentList: window.proxyUrl + "ContentGw/contentlist/",
  getAllContentOwnersBasedOnConsumerUser:
    window.proxyUrl + "ContentGw/getAllContentOwners/",
  getContentListBasedOnConsumerUserandContentOwner:
    window.proxyUrl + "ContentGw/contentlist/",
  getContentBasedOnSiteId: window.proxyUrl + "ContentGw/getContent/",
  getAllSitesBasedOnConsumerUser: window.proxyUrl + "ContentGw/getAllSites/",
  getSiteContent: window.proxyUrl + "ContentGw/getSiteContent/",
  getContentSubcategories:
    window.proxyUrl + "ContentGw/getAllContentSubCategories/",
  getFarmUpdates: window.proxyUrl + "ContentGw/contentsList/",
  getProductsBasedonCategoryId:
    window.newBaseUrlOEM + "AgriProductProxy/product/",
  // "getProductsBasedonCategoryId" : window.newServerContent+"AgriProductProxy/product/",

  getFarmUpdatesLists: window.proxyUrl + "ContentGw/contentsList/",
  getAssetTypeBasedOnAssetDeveleper: window.newBaseUrlOEM + "EAP/assetTypes/",
  getAllContentOwnersBasedOnCategory:
    window.proxyUrl + "ContentGw/consumer2/contentowners/",
  getSubCategoriesBasedonCategoryID: window.proxyUrl + "ContentGw/",

  userInfo: window.OpUserServiceUrl + "OpUserService/consumerReqInfo",

  contentLikeCount: window.newBaseUrlOEM + "ContentGw/updatelikecount/",
  getContentCreator: window.proxyUrl + "ContentGw/",
  getContentonContentCreator: window.proxyUrl + "ContentGw/contentlist/",
  sendRequest:
    window.AgriBusinessRegistryServiceUrl +
    "AgriBusinessRegistryService/register/",

  getRoleType: window.OpUserServiceUrl + "OpUserService/getRole/",
  getRoleTypeResource: window.OpUserServiceUrl + "OpUserService/getResources/",
  getAllCategoriesBasedonCategoryTypeID:
    window.proxyUrl + "ContentGw/categorylist/",
  /************************END OF WEBSITE URL***************************** */
};

window.googleAnalytics = {
  accountId: 185833573,
  accountName: "Unaas",
  propertyId: 256711934,
  propertyName: "Test-Property",
};
